import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function AllYourSiteMenu({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/site/all"
        className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(activeItem, "all-my-site-menu")} `}
      >
        <i class="fa-solid fa-tv pl-2"></i>
        <p>سایت ها نمایش دهنده </p>
      </Link>
    </li>
  );
}
